import { render } from "./ProfiloUtente.vue?vue&type=template&id=0cc67e72&ts=true"
import script from "./ProfiloUtente.vue?vue&type=script&lang=ts"
export * from "./ProfiloUtente.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__